export default {
    idDonor: (state) => state.idDonor,
    temporaryAccount: (state) => state.temporaryAccount,
    firstName: (state) => state.firstName,
    lastName: (state) => state.lastName,
    dob: (state) => state.dob,
    phoneMobile: (state) => state.phoneMobile,
    email: (state) => state.email,
    street: (state) => state.street,
    city: (state) => state.city,
    state: (state) => state.state,
    country: (state) => state.country,
    zipCode: (state) => state.zipCode,
    lat: (state) => state.lat,
    lng: (state) => state.lng,
    determinationCoordinates: (state) => state.determinationCoordinates,

    bloodType: (state) => state.bloodType,
    smsOptedOut: (state) => state.smsOptedOut,
    donorId:  (state) => state.donorId,

    //numberOfPointsEarned: (state) => state.numberOfPointsEarned,
    pointsTotal: (state) => state.pointsTotal,
    sumRewardsPoints: (state) => state.sumRewardsPoints,
    lifetimeDonations: (state) => state.lifetimeDonations,
    lifetimeDonationsWbc: (state)=> state.lifetime_donations_wb_c,
    lifetimeDonationsPlt: (state)=> state.lifetime_donations_plt_c,
    lifetimeDonationsDrbc: (state)=> state.lifetime_donations_drbc_c,
    lifetimeDonationsAlyrp: (state)=> state.lifetime_donations_alyrp_c,
    lifetimeDonationsTotal: (state)=> state.lifetime_donations_total_c,
}
